import actions from './actions.js'
import mutations from './mutations.js'
import getters from './getters.js'
import moment from 'moment'
import { usesFirebaseSession } from '@/utils/session-config'

const state = {
  session: {
    status: 'initializing',
    authorization: null,
    claims: {},
    principal: null,
    generation: 0
  },
  accessToken: null,
  refreshToken: null,
  firebaseToken: null,
  lastActivity: moment().utc().unix(),
  isInactive: false,
  profile: null,
  notificationMarks: null,
  heartbeat: null
}

// Attempt to get tokens from local storage
const accessToken = localStorage.getItem('blytzpay_access_token')
const refreshToken = localStorage.getItem('blytzpay_refresh_token')
const firebaseToken = localStorage.getItem('blytzpay_firebase_token')

if (!usesFirebaseSession() && accessToken) {
  state['accessToken'] = accessToken
  state['refreshToken'] = refreshToken
  state['firebaseToken'] = firebaseToken
}

export default {
  state: () => state,
  mutations,
  actions,
  getters
}
